export const siteUrl = 'https://www.learncybersec.org';
// export const authUrl =
//   'http://localhost:5001/progaming-cybersecurity/us-central1/entergame';
export const authUrl =
  'https://asia-northeast1-progaming-cybersecurity.cloudfunctions.net/entergame';
export const gameUrl = 'https://play.learncybersec.org';
